import { AI_TAG_CATEGORY_BADGE_MAP, aiTagCategoryLabel } from '@/common/app/modules/recommend/aiTag'
import { EffectivenessTag } from '@/common/model/recommend/aiTag'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import ItemAlign from '@/components/view/layouts/item/ItemAlign'

interface Props {
  tag: EffectivenessTag
  rank: number
  maxCvr: number
  maxCtr: number
}

const AITagEffectivenessListRow = ({ tag, rank, maxCvr, maxCtr }: Props) => {
  const isTop5 = rank < 5

  return (
    <TableRow>
      <TableRowItem>
        <ItemAlign gapX={16} align='center'>
          <Badge badgeType={isTop5 ? BadgeType.SQUARE_CAUTION : BadgeType.SQUARE_TERTIARY}>
            <ItemAlign gapX={2} align='center'>
              {isTop5 && <Icon type={IconType.CROWN} color={IconColor.CAUTION} />}
              <Text
                color={isTop5 ? TextColor.CAUTION : TextColor.PRIMARY}
                weight={isTop5 ? 'bold' : 'normal'}
              >
                {rank + 1}
              </Text>
            </ItemAlign>
          </Badge>
          <Text weight='bold'>{tag.tag_name}</Text>
        </ItemAlign>
      </TableRowItem>
      <TableRowItem width={160}>
        <Text>{aiTagCategoryLabel(tag.tag_category)}</Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text
          size={isTop5 ? 16 : 14}
          weight={isTop5 ? 'bold' : 'normal'}
          color={isTop5 ? TextColor.CAUTION : TextColor.PRIMARY}
        >
          {tag.effectiveness_score}
        </Text>
      </TableRowItem>
      <TableRowItem width={88}>
        <Text>{tag.product_count}</Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text>{tag.clicks_30d.toLocaleString()}</Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text color={TextColor.BRAND} weight='bold'>
          {tag.ctr}%
        </Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text>{tag.views_30d.toLocaleString()}</Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text>{tag.purchases_30d.toLocaleString()}</Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text color={TextColor.BRAND} weight='bold'>
          {tag.cvr}%
        </Text>
      </TableRowItem>
    </TableRow>
  )
}

export default AITagEffectivenessListRow
